import { lazy } from 'react'
import { VISTAS_GESTION } from './lib/tabsEmpresa'

/**
 * Módulo: Gestión
 * Empresas, tareas, accionables, SLAs, reuniones, reportes.
 */
export default {
  id: 'gestion',
  nombre: 'Gestión',
  descripcion: 'Gestión operativa de empresas, tareas, SLAs y reportes',
  icono: 'briefcase',
  tipo: 'core',
  version: '1.0.0',
  // Visible para admin y consultores; clientes tienen su módulo 'portal'

  routes: [
    { path: 'empresas', component: lazy(() => import('./pages/EmpresasPage')) },
    { path: 'empresas/:id', component: lazy(() => import('./pages/EmpresaDetailPage')) },
    { path: 'cuentas', component: lazy(() => import('./pages/CuentasPage')) },
    { path: 'categorias', component: lazy(() => import('./pages/CategoriasPage')) },
    { path: 'tipos-negocio', component: lazy(() => import('./pages/TiposNegocioPage')) },
    { path: 'equipo-empresa', component: lazy(() => import('./pages/EquipoEmpresaPage')) },
    { path: 'equipo-proyecto', component: lazy(() => import('./pages/EquipoProyectoPage')) },
    { path: 'locaciones', component: lazy(() => import('./pages/LocacionesPage')) },
    { path: 'organizaciones', component: lazy(() => import('./pages/OrganizacionesPage')) },
    { path: 'accionables', component: lazy(() => import('./pages/AccionablesPage')) },
    { path: 'mis-tareas', component: lazy(() => import('./pages/MisTareasPage')) },
    { path: 'tipos-asignacion', component: lazy(() => import('./pages/TiposAsignacionPage')) },
    { path: 'slas', component: lazy(() => import('./pages/SLAsPage')) },
    { path: 'reportes', component: lazy(() => import('./pages/ReportesPage')) },
    // Compat: la ABM de tipos de reunión se mudó al módulo Plataforma como
    // "Auto-meeting" (sumando el editor de prompts del análisis IA).
    // /tipos-reunion ahora hace Navigate a /auto-meeting así no rompemos
    // bookmarks ni el link viejo de AdminPage.
    { path: 'tipos-reunion', component: lazy(() => import('./pages/TiposReunionRedirect')) },
    { path: 'glosario', component: lazy(() => import('./pages/GlosarioPage')) },
    { path: 'usuarios', component: lazy(() => import('./pages/UsuariosPage')) },
  ],

  // #87 — `permisoModulo` filtra item-by-item según el rol.
  // Orden definido por Mariano (7-jul). Todos los ítems apuntan a rutas que
  // viven en sus módulos de origen (mensajes→comunicaciones, mis-tareas/
  // calendario→asignaciones, mis-casos→casos, proyectos→proyectos,
  // empresas→gestion, mercado→mercado); acá solo se ordenan los ítems del menú.
  menuItems: [
    { label: 'Mensajes', path: '/mensajes', icon: 'message-square', badge: 'unread', permisoModulo: 'mensajes' },
    { label: 'Mis actividades', path: '/mis-tareas', icon: 'target', permisoModulo: 'asignaciones' },
    { label: 'Mis casos', path: '/mis-casos', icon: 'user-circle', permisoModulo: 'casos' },
    { label: 'Mis proyectos', path: '/proyectos?mios=1', icon: 'check-square', permisoModulo: 'proyectos' },
    // "Calendario" se mudó al grupo "Analizar Borrar" (rentabilidad/config.js)
    // el 7-jul — la ruta /calendario sigue en asignaciones/config.js.
    { label: 'Mis empresas', path: '/empresas', icon: 'building', permisoModulo: 'empresas' },
    { label: 'Explorador de mercado', path: '/mercado/explorador', icon: 'bar-chart-2', permisoModulo: 'mercado' },
    // Conocimiento Ecosistema (14-jul-2026): benchmarks anónimos de la plataforma.
    // 4-ago-2026 (pedido Mariano): sub-menú en el sidebar con las 3 secciones
    // (reemplaza las chips arriba de la página). Los hijos heredan el gate
    // {conocimiento, ver} del padre — se declara UNA vez acá.
    {
      label: 'Conocimiento', path: '/conocimiento', icon: 'book-open', permisoModulo: 'conocimiento',
      children: [
        { label: 'Costos Mercado Libre', path: '/conocimiento/costos-ml', icon: 'globe' },
        { label: 'Reclamos y Devoluciones', path: '/conocimiento/salud-reclamos', icon: 'alert-triangle' },
        { label: 'Preguntas vs Ventas', path: '/conocimiento/salud-preguntas', icon: 'message-square' },
      ],
    },
  ],

  features: [
    'empresas',
    'tareas',
    'accionables',
    'slas',
    'reuniones',
    'reportes',
  ],

  // Vistas gateables que aporta este módulo al árbol de "Vista detallada de
  // empresa" (Plataforma Configuración): los sub-tabs de la página de empresa.
  vistasEmpresa: VISTAS_GESTION,

  // permisoModulos (#58): permiso-módulos del catálogo v2 que gatean este
  // app-módulo en el sidebar. El grupo se muestra si el rol del usuario tiene
  // 'ver' en al menos uno. Reemplaza al sistema de Vistas.
  // Incluye el código de cada ítem del menú cuya ruta monta este módulo: lo exige `src/core/lib/menuRutaPermiso.guard.test.js`.
  permisoModulos: ['empresas', 'accionables', 'asignaciones', 'usuarios', 'slas', 'reportes'],

}
